<template>
  <div class="flex min-h-screen w-full flex-col justify-between">
    <NuxtErrorBoundary>
      <AppNavigation />
      <DesktopNavigation class="max-lg:hidden" />

      <main class="my-32 flex flex-1 flex-col items-center justify-center">
        <h1 class="mx-auto text-4xl font-bold">
          {{ error.statusCode }}
        </h1>
        <h2 class="mx-auto my-4 max-w-xl">
          {{
            props.error.statusCode === 404 ? $t('error.404') : $t('error.500')
          }}
        </h2>

        <!-- LINK -->
        <button
          type="button"
          :aria-label="$t('error.backToHomepage')"
          class="rounded-full bg-[#2563eb] px-7 py-2.5 font-medium text-white"
          @click="handleError('/')"
        >
          <I18nT
            tag="span"
            keypath="error.backToHomepage"
          />
        </button>

        
      </main>
    </NuxtErrorBoundary>

    <NuxtErrorBoundary>
      <AppFooter />
    </NuxtErrorBoundary>
  </div>
</template>

<script setup lang="ts">
if (import.meta.client) {
  document.body.classList.add(useIsTouchDevice() ? 'is-touch' : 'no-touch')
}

const props = defineProps<{ error: any }>()

try {
  provide(GlobalsKey, await useInjectableGlobals())
} catch (error) {
  console.error('[ERROR Page]: Could not load globals', error)
}

const handleError = (uri: string) => {
  clearError({ redirect: uri })
}

const gqlErrorData = computed(() => {
  if (!props.error.data) return null

  return JSON.parse(props.error.data)
})

const errorMessage = computed(() => {
  if (!gqlErrorData.value) return props.error.statusMessage

  return `${props.error.statusMessage} - ${gqlErrorData.value.message}`
})
</script>
